import { useSelector } from "react-redux";

import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import ChangePasswordForm from "@/features/users/settings/components/ChangePasswordForm";
import ChangeEmailForm from "@/features/users/settings/components/ChangeEmailForm";
import DeleteAccountSection from "@/features/users/settings/components/DeleteAccountSection";
import ExportDataSection from "@/features/users/settings/components/ExportDataSection";

const AccountSettings = () => {
  const currentUser = useSelector(selectCurrentUser);

  if (!currentUser) return <BaseSpinner />;

  return (
    <div className="page-layout">
      <ChangePasswordForm userId={currentUser.id} />
      <ChangeEmailForm userId={currentUser.id} />
      <ExportDataSection
        userId={currentUser.id}
        fullName={currentUser.fullName}
      />
      <DeleteAccountSection userId={currentUser.id} />
    </div>
  );
};

export default AccountSettings;
